import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { useNavigate } from 'src/utils/useNavigate';
import routes from 'src/constants/routes';
import useAuthorization from 'src/dataHooks/useAuthorization';
import PageSpin from 'src/components/PageSpin';
import { AuthorizationContext } from 'src/contexts/authorizationContext';

const AuthorizedRoute: React.FC = () => {
  const { authorizationState, fetchAuthorizationState } = useAuthorization();
  const navigate = useNavigate();

  useEffect(() => {
    fetchAuthorizationState();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (authorizationState && !authorizationState.userId) {
      navigate(routes.main);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authorizationState]);

  // В сценарии редиректа нужно продолжать рендерить спинер. В противном случае до эффекта с редиректом успеет запуститься рендеринг вложенных компонентов.
  if (!authorizationState || !authorizationState?.userId) {
    return <PageSpin />;
  }

  return (
    <AuthorizationContext.Provider value={authorizationState}>
      <Outlet />
    </AuthorizationContext.Provider>
  );
};

export default AuthorizedRoute;
